import { render, staticRenderFns } from "./OrdersFilters.vue?vue&type=template&id=97810c1e&scoped=true&lang=pug"
import script from "./OrdersFilters.vue?vue&type=script&lang=js"
export * from "./OrdersFilters.vue?vue&type=script&lang=js"
import style0 from "./OrdersFilters.vue?vue&type=style&index=0&id=97810c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97810c1e",
  null
  
)

export default component.exports